import {Exemption, FormPetroleumPort} from "@portbase/bezoekschip-service-typescriptmodels";

const attachmentRequiredExemptionTypes: string[] = [
  "Exemption 3.4",
  "Exemption 3.13",
  "Exemption 4.1",
  "Exemption 4.5",
  "Exemption 4.6",
  "Exemption 5.3",
  "Exemption 8.1"
]

const attachmentConditionallyRequiredExemptionTypes = new Map<string, string[]>([
  ["Exemption 5.4, 5.5, 5.6", ["All cargo tanks (including slop tanks) are completely empty and clean",
                               "Cargo tanks are loaded or empty but not gas-free"]],
  ["Exemption 5.4, 5.6, 5.7", ["All cargo tanks (including slop tanks) are completely empty and clean",
                               "Cargo tanks are loaded or empty but not gas-free"]]
]);

const vesselsRequiredExemptionTypes: string[] = [
  "Exemption 6.4"
]

const inertTanksRequiredExemptionTypes: string[] = [
  "Exemption 5.4, 5.5, 5.6",
  "Exemption 5.4, 5.6, 5.7",
]

export function attachmentRequired(exemption: Exemption): boolean {
  if (attachmentRequiredExemptionTypes.includes(exemption.exemptionType)) {
    return true;
  }
  if (attachmentConditionallyRequiredExemptionTypes.has(exemption.exemptionType)) {
      if(attachmentConditionallyRequiredExemptionTypes.get(exemption.exemptionType).includes((exemption as FormPetroleumPort).conditionType)) {
        return true;
      }
  }
  return false;
};

export function vesselsRequired(exemptionType: string): boolean {
  if (vesselsRequiredExemptionTypes.includes(exemptionType)) {
    return true;
  }
  return false;
};

export function inertTanksRequired(exemptionType: string): boolean {
  if (inertTanksRequiredExemptionTypes.includes(exemptionType)) {
    return true;
  }
  return false;
};

export function getTooltipAttachment(exemptionType: string): any {
  switch (exemptionType) {
    case "Exemption ISPS":
      return 'Description of works, such as a plan with (equivalent) security arrangement or other relevant documents. The Declaration of Security can be added here !';
    case "Exemption Tijpoort":
      return 'Stability report of the arrival condition';
    case "Exemption 3.4":
      return 'Mooring Plan is required';
    case "Exemption 3.13":
      return 'Action Plan or Task Analysis is required';
    case "Exemption 4.1":
      return 'Task Risk Analysis is required';
    case "Exemption 4.5":
      return 'Action Plan is required if the work take longer then 7 days. ' +
        'Gas doctor\'s statement is required if health and safety certificate been issued.';
    case "Exemption 4.6":
      return 'Decontamination plan is required';
    case "Exemption 4.11b":
      return 'If the terminal or facility agree with the cleaning operations, add proof that the terminal or facility is in agreement';
    case "Exemption 5.3":
      return 'Task Risk analysis and/or Plan of Action  is required. Also a Safety and Health certificate from a Gasdoctor is required';
    case "Exemption 5.4, 5.5, 5.6":
      return 'Add the stowage plan and/or final load specifications, together with the report of findings by a recognized gas expert, if applicable.';
    case "Exemption 5.4, 5.6, 5.7":
      return 'Add the stowage plan and/or final load specifications, together with the report of findings by a recognized gas expert, if applicable.';
    case "Exemption 8.1":
      return 'Joint Plan of Operation and Compatibility Study is required';
    default :
      return false;
  }
}
